import { type Theme } from "@mui/material"
import { SimpleWidgetCardTheme } from "../../../definitions/components.types"
import { simpleWidgetCardClasses } from "../../../themeTypes"

export const createSimpleWidgetCardTheme = (_: Theme): SimpleWidgetCardTheme => ({
    variants: [
        {
            props: { widgetVariant: "startpage" },
            style: {
                padding: "10px",
                [`.${simpleWidgetCardClasses.card}`]: {
                    boxShadow: "0 1px 5px 0 rgba(0,0,0,.13)",
                    border: "1px solid transparent",
                    padding: "1em",
                    "&:hover": {
                        background: "#fff",
                        border: "1px solid #f4a628",
                    },
                },
            },
        },
        {
            props: { widgetVariant: "dashboard" },
            style: {
                [`.${simpleWidgetCardClasses.card}`]: {
                    padding: "1em",
                },
            },
        },
    ],
})
